import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constant/api-collection";

@Injectable({
    providedIn: "root"
})
export class CategoryService {
    constructor(private apiService: ApiService) { }

    getCategoryList(parameters: any): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            this.apiService.get({ url: apiColletions.getCategories, parameters }).subscribe({
                next: (response) => {
                    if (response.data) {
                        observer.next(response.data);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }

    getCategoryWiseProductList(parameters: any): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            this.apiService.get({ url: apiColletions.categoryWiseProductList, parameters }).subscribe({
                next: (response) => {
                    if (response.data) {
                        observer.next(response.data.data);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }

}
